module.exports = __webpack_public_path__ + "static/img/healey-sam.21a9bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healey-sam.jpg
// module id = Pblr
// module chunks = 0